module.exports = __webpack_public_path__ + "static/mobile-mock-web-c8016cb510a0e39eb40fcea9c9c5bc35.svg";